import { useEffect, useState } from 'react';
import { EditorName } from '../config/handlers/EditorEventsHandlers';
import { getDocumentHeadings } from '../util/DocumentNavigationUtils';

export type LiveHeading = {
  isSectionTitle: boolean;
  level: number;
  text: string;
};

export function useLiveHeadings(editorName: EditorName, enabled: boolean) {
  const [liveHeadings, setLiveHeadings] = useState<LiveHeading[]>([]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const container = document.getElementById(editorName);
    if (!container) {
      return;
    }
    const readHeadings = () => {
      setLiveHeadings(
        getDocumentHeadings(editorName).map((heading) => ({
          isSectionTitle: heading.classList.contains('section-heading'),
          level: Number(heading.tagName[1]),
          text: heading.textContent?.trim() ?? '',
        })),
      );
    };
    readHeadings();
    const observer = new MutationObserver(readHeadings);
    observer.observe(container, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    return () => observer.disconnect();
  }, [editorName, enabled]);

  return liveHeadings;
}
